<script lang="ts">
	import type { BrightnessBoostValue } from "./types"

	interface Props {
		value: BrightnessBoostValue
	}

	let { value = $bindable() }: Props = $props()
</script>

<div class="input-container select-container editor-input">
	<label for="brightness-modifier">Brightness Booster: </label>
	<select
		id="brightness-modifier"
		name="brightness_modifier"
		onchange={(e) => {
			value = e.currentTarget.value as BrightnessBoostValue
		}}
		{value}
	>
		<option value="off">Off</option>
		<option value="low">Bright</option>
		<option value="med">Brighter</option>
		<option value="high">Brightest</option>
	</select>
</div>

<style>
</style>
